export default "__VITE_ASSET__CKy6v4Tb__"